import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import cx from 'classnames';
import StackNavigator from '../../../components/stateful/StackNavigator';
import styles from './MobileNav.scss';
import PlaceholderIcon from '../../../../modules/react/components/stateless/PlaceholderIcon';
import MobileNavbarButton from '../../../components/stateless/MobileNavbarButton/MobileNavbarButton';


const propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.shape({
    page: PropTypes.shape({
      path: PropTypes.string,
      title: PropTypes.string.isRequired,
    }),
    text: PropTypes.string,
    link: PropTypes.shape({
      target: PropTypes.string,
      href: PropTypes.string,
    }),
    navigationItems: PropTypes.array,
  })),
};

const defaultProps = {
  navigation: [],
};

const MobileNav = ({ navigation }) => {
  const ref = useRef(null);
  const [navExpanded, updateNavExpanded] = useState(false);
  const [title, updateTitle] = useState();
  const [back, updateBack] = useState(false);
  const [topOffset, updateTopOffset] = useState(0);

  useEffect(() => {
    if (!ref) { return; }

    const boundingRect = ref.current.getBoundingClientRect();
    updateTopOffset(boundingRect.top);
  }, [ref]);

  // Look, this just triggers a listener... Don't question it too hard.
  const toggleBack = () => {
    updateBack(!back);
  };
  const toggleNav = () => {
    document.body.classList.toggle('hide-overflow', !navExpanded);
    updateNavExpanded(!navExpanded);
  };

  return (
    <>
      <div className={
        cx(styles.navHeader, { [styles.overlay]: !!title })
      }
      >
        {title
          ? (
            <div className={styles.titleDiv}>
              <button className={styles.navBackButton} type="button" onClick={toggleBack}>
                <PlaceholderIcon.LeftChevron />
              </button>
              <span className={styles.title}>{title || ''}</span>
            </div>
          ) : <div />}

          <MobileNavbarButton toggleNav={toggleNav} navExpanded={navExpanded} />

      </div>
      <div ref={ref} style={navExpanded ? { height: `calc(100vh - ${topOffset + 48}px)` } : null}>
        <StackNavigator
          visible={navExpanded}
          transition={'right'}
          items={navigation}
          back={back}
          updateTitle={updateTitle}
        />
      </div>
    </>
  );
};

MobileNav.propTypes = propTypes;
MobileNav.defaultProps = defaultProps;

MobileNav.fragments = (() => {
  const page = gql`
    fragment MobileNavNavigationItemPageFields on Page {
      path
      title
    }
  `;

  const navigationItemFields = gql`
    fragment MobileNavNavigationItemFields on NavigationItem {
      id
      text
      link {
        href
        target
      }
      page {
        id
        ...MobileNavNavigationItemPageFields
      }
    }

    ${page}
  `;

  return {
    navigationItem: gql`
      fragment MobileNavNavigationItems on NavigationItem {
        ...MobileNavNavigationItemFields
        navigationItems {
          ...MobileNavNavigationItemFields
          navigationItems {
            ...MobileNavNavigationItemFields
            navigationItems {
              ...MobileNavNavigationItemFields
            }
          }
        }
      }

      ${navigationItemFields}
    `,
    page,
  };
})();

export default MobileNav;
